"use client";

import { useEffect, useRef } from "react";
import posthog from "posthog-js";
import { useAuth } from "@/context/AuthContext";

interface JwtPayload {
  sub?: string;
  email?: string;
}

function decodePayload(token: string): JwtPayload | null {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch {
    return null;
  }
}

export default function PostHogIdentify() {
  const { token } = useAuth();
  const identifiedAs = useRef<string | null>(null);

  useEffect(() => {
    if (!process.env.NEXT_PUBLIC_POSTHOG_KEY) return;

    if (!token) {
      if (identifiedAs.current !== null) {
        posthog.reset();
        identifiedAs.current = null;
      }
      return;
    }

    const payload = decodePayload(token);
    const userId = payload?.sub;
    if (!userId || identifiedAs.current === userId) return;

    posthog.identify(userId, payload.email ? { email: payload.email } : undefined);
    identifiedAs.current = userId;
  }, [token]);

  return null;
}
